module.exports = __webpack_public_path__ + "img/charity-volunteer-campaign.2259b933.jpg";